module.exports = __webpack_public_path__ + "img/3600.7dcb502f.jpg";